import axios from "axios";
import { getConfig } from "../loadconfig";
import Constants from "../utils/Constants";


const logoCategory = 'Logos';

export const fetchImageFromAzureBlobStorage = async (imageFileName) => {
    let config = getConfig();
    let baseUrl = config.CONTENTENDPOINT;
    let subscriptionKey = config.CONTENTSUBSCIPTIONKEY;
   
    try {
        const { data } = await axios.get(`${baseUrl}`, {
            params: {
                'category': logoCategory,
                'contentType': '',
                'contentVariable': imageFileName
            },
            headers: {
                "Ocp-Apim-Subscription-Key": subscriptionKey
            }
        });
        console.log("API data", data);
        return data;
    } catch (error) {
        console.log("Error")
        throw error;
    }
}

export const fetchContentFromAzureBlobStorage = async (lang, contenttype, contentVariable) => {
    let config = getConfig();
    let baseUrl = config.CONTENTENDPOINT;
    let subscriptionKey = config.CONTENTSUBSCIPTIONKEY;
    
    try {
        const { data } = await axios.get(`${baseUrl}`, {
            params: {
                'category': lang == 'en' ? 'English' : 'Spanish',
                'contentType': contenttype,
                'contentVariable': contentVariable
            },
            headers: {
                "Ocp-Apim-Subscription-Key": subscriptionKey
            }
        });
        console.log("API data", data);
        return data;
    } catch (error) {
        console.log("Error")
        throw error;
    }
};

export const getProviderSearchImage = async (clientsuffix) => {
 
            if (clientsuffix != null && clientsuffix != undefined && clientsuffix != "" && clientsuffix != "undefined" && clientsuffix != "null") {
                try {
                    const imageData = await fetchImageFromAzureBlobStorage(Constants.CLIENTPREFIX + clientsuffix.toUpperCase() + ".png");
                    return imageData;
                } catch (error) {

                    try {
                    const imageData = await fetchImageFromAzureBlobStorage(Constants.CLIENTPREFIX + clientsuffix.toUpperCase() + ".gif");
                    return imageData;
                        
                    } catch (errorVal) {
                        
                        try {
                            const imageData = await fetchImageFromAzureBlobStorage(Constants.CLIENTPREFIX + clientsuffix.toUpperCase() + ".jpg");
                            return imageData;
                                
                            } catch (e) {
                                
                                console.log(e.message);
                                return null;
                            }
                    }

            }
        }
        return null;
    };

export const fetchGET = async (url, queryParams, mycontext, params) => {
    let config = getConfig();
    let subscriptionKey = config.CONTENTSUBSCIPTIONKEY;
    const { jwtToken, tokenSessionTime, setJwtTokenData } = mycontext;
    const tmpjwtToken = jwtToken;
    isTokenExpired(tokenSessionTime, setJwtTokenData);
    try {
     
        const psConfig = queryParams['ProviderSearchConfig'];
        const siteurl = queryParams['SiteUrlSuffix'];
        const siteId = queryParams['SiteId'];

        // Check if 'someParam' was passed
        if (siteurl != null || siteId != null) {
            params['ProviderSearchConfig'] = psConfig;
            params['SiteUrlSuffix'] = siteurl;
            params['SiteId'] = siteId;
        }

        const { data } = await axios.get(url, { params, 
            headers: { "Ocp-Apim-Subscription-Key": subscriptionKey, 
                    "JWT-Token": tmpjwtToken
            } });
        return data;
    } catch (error) {
        console.log("Error")
        throw error;
    }
}


export const fetchData = async (url, searchCriteria, mycontext) => {
    const { jwtToken, tokenSessionTime, setJwtTokenData } = mycontext;
    let config = getConfig();
    let subscriptionKey = config.CONTENTSUBSCIPTIONKEY;
    const tmpjwtToken = jwtToken;
    isTokenExpired(tokenSessionTime, setJwtTokenData);
    try {

        const response = await axios.post(url,
            searchCriteria,
            {
                headers: { "Ocp-Apim-Subscription-Key": subscriptionKey,
                    "JWT-Token": tmpjwtToken,
                    'Content-Type': 'application/json'
                 }
            });
        const { data } = response;
        return data;
    } catch (error) {
        console.log("Error")
        throw error;
    }
}

export const validate = async (url, type, recaptchaToken) => {
    let config = getConfig();
    let subscriptionKey = config.CONTENTSUBSCIPTIONKEY;

    try {

        const response = await axios.post(url,
            {"type": type},
            {
                headers: { "Ocp-Apim-Subscription-Key": subscriptionKey,
                    "ReCaptcha-Token": recaptchaToken,
                    'Content-Type': 'application/json'
                 }
            });
        const { data } = response;
        return data;
    } catch (error) {
        console.log("Error")
        throw error;
    }
}

export const fetchpdf = async (url, searchCriteria,mycontext) => {
    let config = getConfig();
    let subscriptionKey = config.CONTENTSUBSCIPTIONKEY;
    const { jwtToken, tokenSessionTime, setJwtTokenData } = mycontext;
    const tmpjwtToken = jwtToken;
    isTokenExpired(tokenSessionTime, setJwtTokenData);

    try {

        const response = await axios.post(url,
            searchCriteria,
            {
                headers: {
                    "Ocp-Apim-Subscription-Key": subscriptionKey,
                    'Content-Type': 'application/json',
                    "JWT-Token": tmpjwtToken
                },
                responseType: 'blob'
            });
        if (response.status !== 200) {
            throw new Error('Network response was not ok');
        }
        return response.data;
    } catch (error) {
        console.log("Error")
        throw error;
    }
}
export const sendEmailResult = async (url, searchCriteria,mycontext) => {
    let config = getConfig();
    let subscriptionKey = config.CONTENTSUBSCIPTIONKEY;
    const { jwtToken, tokenSessionTime, setJwtTokenData } = mycontext;
    const tmpjwtToken = jwtToken;
    isTokenExpired(tokenSessionTime, setJwtTokenData);

    try {
        const response = await axios.post(url,
            searchCriteria,
            {
                headers: {
                    "Ocp-Apim-Subscription-Key": subscriptionKey,
                    'Content-Type': 'application/json',
                    "JWT-Token": tmpjwtToken
                },
            });
        if (response.status !== 200) {
            throw new Error('Network response was not ok');
        }
        return response.data;
    } catch (error) {
        console.log("Error")
        throw error;
    }
}
export const fetchAutoSuggest = async (url, mycontext) => {
    let config = getConfig();
    let subscriptionKey = config.CONTENTSUBSCIPTIONKEY;
    const { jwtToken, tokenSessionTime, setJwtTokenData } = mycontext;
    const tmpjwtToken = jwtToken;
    isTokenExpired(tokenSessionTime, setJwtTokenData);

    try {
       

        const { data } = await axios.get(url, { 
            headers: { "Ocp-Apim-Subscription-Key": subscriptionKey, 
                        "JWT-Token": tmpjwtToken
            } });
        return data;
    } catch (error) {
        console.log("Error")
        throw error;
    }
}

export const fetchNationalProvider = async (url, params, mycontext) => {
   
    const { jwtToken, tokenSessionTime, setJwtTokenData } = mycontext;
    const tmpjwtToken = jwtToken;

    isTokenExpired(tokenSessionTime, setJwtTokenData);

    let config = getConfig();
    let subscriptionKey = config.CONTENTSUBSCIPTIONKEY;
    try {    

        const response = await axios.get(url, {  params, 
            headers: { 
                "Ocp-Apim-Subscription-Key": subscriptionKey,
                'Content-Type': 'application/json',
                "JWT-Token": tmpjwtToken 
            } 
        });
        if (response.status !== 200) {
            throw new Error('Network response was not ok');
        }
        
        return response.data;
    } catch (error) {
        console.log("Error")
        throw error;
    }
}

export const trackingPublishEvent = async (url, eventData, jwtToken) => {

    if(jwtToken === "") {
        return;
    }
    let config = getConfig();
    let subscriptionKey = config.CONTENTSUBSCIPTIONKEY;
    try {
 
        const response = await axios.post(url,
            eventData,
            {
                headers: { "Ocp-Apim-Subscription-Key": subscriptionKey,
                    "JWT-Token": jwtToken,
                    'Content-Type': 'application/json'
                 }
            });
        const { data } = response;
        return data;
    } catch (error) {
        console.log("Error")
        throw error;
    }
}

export const reportInvalidInfo = async (url, invalidReportData, mycontext) => {
    let config = getConfig();
    let subscriptionKey = config.CONTENTSUBSCIPTIONKEY;
    const { jwtToken, tokenSessionTime, setJwtTokenData } = mycontext;
    const tmpjwtToken = jwtToken;
    isTokenExpired(tokenSessionTime, setJwtTokenData);

    try {

        const response = await axios.post(url,
            invalidReportData,
            {
                headers: { "Ocp-Apim-Subscription-Key": subscriptionKey,
                    "JWT-Token": tmpjwtToken,
                    'Content-Type': 'application/json'
                 }
            });
        const { data } = response;
        return data;
    } catch (error) {
        console.log("Error")
        throw error;
    }
}

export const fetchAffiliatedNetworkPractitioner = async (url, params, mycontext) => {
    let config = getConfig();
    let subscriptionKey = config.CONTENTSUBSCIPTIONKEY;
    const { jwtToken, tokenSessionTime, setJwtTokenData } = mycontext;
    const tmpjwtToken = jwtToken;
    isTokenExpired(tokenSessionTime, setJwtTokenData);

    try {
        const response = await axios.post(url, params, 
           { headers: { 
                "Ocp-Apim-Subscription-Key": subscriptionKey,
                "JWT-Token": tmpjwtToken ,
                'Content-Type': 'application/json'
            }
        });
        if (response.status !== 200) {
            throw new Error('Network response was not ok');
        }
        return response.data;
    } catch (error) {
        console.log("Error")
        throw error;
    }
}

const isTokenExpired = (tkTime, setJwtToken) => {

    if(tkTime) {
        const currentTime = new Date().getTime();
        
        if (currentTime - tkTime >= (8 * 60 * 1000)) { // 8 minutes
            setJwtToken(""); // reset to generate new, it is done in Footer.js
        } 
    } 
}




export default { fetchImageFromAzureBlobStorage, fetchGET, fetchAutoSuggest }; 
